import { of as observableOf, Observable } from "rxjs";

import { catchError } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router } from "@angular/router";

import { DiscussionService } from "../discussion.service";
import { Discussion } from "../../../models";

@Injectable()
export class ViewableDiscussionResolver implements Resolve<Discussion> {
  constructor(
    private discussionService: DiscussionService,
    private router: Router
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const discussionSlug = route.params["discussion"];

    return this.discussionService.findOne(discussionSlug).pipe(
      catchError((err) => {
        this.router.navigateByUrl("/error");
        return observableOf(null);
      })
    );
  }
}
